import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const pickLaterMessage = `Arrival time can't be estimated until final fabric selection is made`;
const ShippingInfoBlock = ({ checkout: { shipping, shippingGroups } }) => {
  const pickLaterGroups = useMemo(
    () =>
      shippingGroups.map(group =>
        Array.isArray(group.cart) && group.cart.length > 0
          ? group.cart.every(product => Boolean(product.pickLater))
          : false
      ),
    [shippingGroups]
  );

  return (
    <div className="mt-8 flex flex-wrap sm:justify-end">
      <div className="min-w-full sm:min-w-[170px] first:mb-[2em] first:sm:mb-0 first:sm:mr-2.5">
        <div className="text-base font-bold [border-bottom:1px_solid_#e5e5e5] pb-2 mb-4">
          Shipping Info
        </div>
        <div className="text-sm">
          {`${shipping.first_name} ${shipping.last_name}`}
          <br />
          {shipping.address}
          <br />
          {shipping.apartment && (
            <>
              {shipping.apartment}
              <br />
            </>
          )}
          {`${shipping.city}, ${shipping.state} ${shipping.zipcode}`}
          {shipping.shipping_email && (
            <>
              <br />
              {shipping.shipping_email}
            </>
          )}
        </div>
      </div>
      <div className="min-w-full sm:min-w-[170px] first:mb-[2em] first:sm:mb-0 first:sm:mr-2.5">
        <div className="text-base font-bold [border-bottom:1px_solid_#e5e5e5] pb-2 mb-4">
          Delivery
        </div>
        <div className="text-sm">
          Estimated Delivery :
          <br />
          {shippingGroups.length === 1
            ? pickLaterGroups[0]
              ? pickLaterMessage
              : shippingGroups[0]?.delivery_dates?.etaDelivery?.short_format
            : null}
          {shippingGroups.length > 1 &&
            shippingGroups.map((shippinggroup, index) => (
              <React.Fragment key={shippinggroup.id ?? index}>
                {`Package ${index + 1}:
                ${
                  pickLaterGroups[index]
                    ? pickLaterMessage
                    : shippinggroup?.delivery_dates?.etaDelivery?.short_format
                }`}
                <br />
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  );
};

ShippingInfoBlock.propTypes = {
  checkout: PropTypes.shape({
    shipping: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      address: PropTypes.string,
      apartment: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipcode: PropTypes.string,
      shipping_email: PropTypes.string,
    }),
    shippingGroups: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        cart: PropTypes.arrayOf(
          PropTypes.shape({
            pickLater: PropTypes.bool,
          })
        ),
        delivery_dates: PropTypes.shape({
          etaDelivery: PropTypes.shape({
            short_format: PropTypes.string,
          }),
        }),
      })
    ),
  }),
};

export default ShippingInfoBlock;
